import Splide from '@splidejs/splide';

const SMALLBP = 600;
const MEDIUMBP = 841;

const primarySliderOptions = {
  width: 230,
  height: 328,
  type: 'fade',
  speed: 200,
  pagination: false,
  arrows: false,
  breakpoints: {
    [MEDIUMBP]: {
      width: 200,
      height: 298,
    },
    [SMALLBP]: {
      width: 157,
      height: 221,
    },
  },
};

const secondarySliderOptions = {
  fixedWidth: 51,
  fixedHeight: 51,
  gap: 10,
  speed: 200,
  arrows: false,
  pagination: false,
  isNavigation: true,
  focus: 'center',
  breakpoints: {
    [MEDIUMBP]: {
      drag: true,
      fixedWidth: 55,
      fixedHeight: 55,
    },
  },
};

const createSlider = (selector, options) => new Splide(selector, options);

export const initializeImageSlider = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const secondarySlider = createSlider(
      '#secondary-slider',
      secondarySliderOptions,
    );

    secondarySlider.mount();

    createSlider('#primary-slider', primarySliderOptions)
      .sync(secondarySlider)
      .mount();
  });
};
